import { useMemo } from "react";
import type { SupDataGridColumn, SupStoredDataGridColumns, SupStoredDataGrids } from "@/types";
import { useStoredData } from "@/store";

export function useGridColumns(gridName: SupStoredDataGrids | undefined, columns: SupDataGridColumn[] = []) {
  const storedData = useStoredData();

  return useMemo(() => {
    if (gridName === undefined) {
      return {
        grid: "Vaults",
        columns: columns.filter(column => column.hiddenByDefault).map(column => column.field),
      } as SupStoredDataGridColumns;
    }
    return (
      storedData.dataGridColumns.find(item => item.grid === gridName) ||
      ({
        grid: gridName,
        columns: columns.filter(column => column.hiddenByDefault).map(column => column.field),
      } as SupStoredDataGridColumns)
    );
  }, [columns, gridName, storedData.dataGridColumns]);
}
